﻿import { create } from "zustand";

// Type voor de store die numbers gebruikt (niet bigint van de API)
type PersoneelsinstellingenStoreModel = {
  voortijd: number;
  natijd: number;
};

type PersoneelsinstellingenStore = {
  personeelsinstellingen: PersoneelsinstellingenStoreModel;
  setPersoneelsinstellingen: (personeelsinstellingen: PersoneelsinstellingenStoreModel) => void;
};

// Default values als fallback
const DEFAULT_PERSONEELSINSTELLINGEN: PersoneelsinstellingenStoreModel = {
  voortijd: 15,
  natijd: 5,
};

export const usePersoneelsinstellingenStore = create<PersoneelsinstellingenStore>((set) => ({
  personeelsinstellingen: DEFAULT_PERSONEELSINSTELLINGEN,
  setPersoneelsinstellingen: (personeelsinstellingen) =>
    set({ personeelsinstellingen: personeelsinstellingen }),
}));
